import React, { useState } from 'react';
import { Box, TextField, Button, Paper, Typography } from '@mui/material';
import { ProductDto } from '../../services/expensesApi';

interface ProductFormProps {
  initial?: Partial<ProductDto>;
  onSubmit: (data: Partial<ProductDto>) => void;
  onCancel?: () => void;
}

const ProductForm: React.FC<ProductFormProps> = ({ initial = {}, onSubmit, onCancel }) => {
  const [name, setName] = useState(initial.name || '');
  const [code, setCode] = useState(initial.code || '');
  const [description, setDescription] = useState(initial.description || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ name, code, description });
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6">{initial.publicId ? 'Editar produto' : 'Adicionar produto'}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Nome"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Código"
          value={code}
          onChange={e => setCode(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Descrição"
          value={description}
          onChange={e => setDescription(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Box mt={2} display="flex" gap={2}>
          <Button type="submit" variant="contained" color="primary">
            Guardar
          </Button>
          {onCancel && (
            <Button variant="outlined" onClick={onCancel}>Cancelar</Button>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default ProductForm;
